<template>
  <div :class="bem()">
    <button :class="bem('title')" @click="showTooltip = !showTooltip">
      {{ props.title }}
    </button>
    <ToolTip v-if="props.content" :content="props.content" :show="showTooltip"/>
  </div>
</template>

<script setup>
const bem = useBEM('NotificationTooltip')

const props = defineProps({
  title: { type: String, required: true, default: '' },
  content: {type: String, required: false, default: '' }
})

const showTooltip = ref(false)
</script>

<style lang="postcss" scoped>
.NotificationTooltip {
  @apply flex justify-between items-center
    border rounded-md
    bg-white
    py-[10px] px-4 mb-4;
}

.NotificationTooltip__title {
  @apply heading-6;
}
</style>